import stoneService from '@services/magento/stone.service';

import { Supplier } from '@stone/interfaces';

export async function fetchSuppliersApi(params?: any): Promise<{ items: Supplier[]; totalCount: number }> {
  const response = await stoneService.getStoneSuppliers(params || {});
  const items = Array.isArray(response) ? response : response?.items || [];
  const totalCount = Array.isArray(response) ? response.length : response?.total_count || 0;
  return { items, totalCount };
}

export async function saveSupplierApi(data: Supplier): Promise<any> {
  return await stoneService.saveStoneSupplier(data);
}

export async function deleteSupplierApi(id: number): Promise<any> {
  return await stoneService.deleteStoneSupplier(id);
}
